webpackJsonp([26],{

/***/ "1B7o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EWIa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LOkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getStringLength;
/* harmony export (immutable) */ __webpack_exports__["a"] = dateFormatter;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatDateMinus;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTimestamp;
/* harmony export (immutable) */ __webpack_exports__["f"] = getZeroDate;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAgeFromBirth;
/* harmony export (immutable) */ __webpack_exports__["g"] = isValidURL;
function getStringLength(str) {
    if (!str) {
        return 0;
    }
    var len = 0;

    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
            len += 2;
        } else {
            len++;
        }
    }

    return len;
}
/**
 * 日期格式化
 * @param date Date 目标日期对象/String 日期对应字符串/ Number: 时间戳(精确到毫秒)
 *        String fmt 指定格式字符串月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)可以用 1-2 个占位符、年(y)可以用 1-4 个占位符、毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * @return Boolean
 */
function dateFormatter(dateTmp, fmtTmp) {
    var fmt = fmtTmp;
    var date = dateTmp;

    if (!fmt) {
        fmt = 'yyyy.MM.dd';
    }
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    var week = {
        "0": "日",
        "1": "一",
        "2": "二",
        "3": "三",
        "4": "四",
        "5": "五",
        "6": "六"
    };

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? "星期" : "周" : "") + week[date.getDay() + ""]);
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return fmt;
}

/**
 * 时间戳格式化(创建时间倒序排列；当天用时分，当周用几天前，其他用年月日)
 * @param Object
 * @return Boolean
 */
function formatDateMinus(time, systime) {
    var nowDate = new Date(systime * 1000);

    nowDate.setHours(23);
    nowDate.setMinutes(59);
    nowDate.setSeconds(59);
    var day = nowDate.getDay();
    var dayMinus = parseInt((Date.parse(nowDate) / 1000 - time) / (60 * 60 * 24));

    if (dayMinus == 0) {
        return dateFormatter(time * 1000, 'HH:mm');
    } else if (dayMinus == 1) {
        return '昨天';
    } else if (dayMinus < 7 && (day - dayMinus > 0 || day == 0)) {
        return dayMinus + '天前';
    } else {
        return dateFormatter(time * 1000);
    }
}
function getTimestamp(date) {
    return Date.parse(date) / 1000;
}
// 获取零点时间
function getZeroDate() {
    var currDate = new Date();
    var year = currDate.getFullYear();
    var month = currDate.getMonth();
    var day = currDate.getDate();

    return new Date(year, month, day, 0, 0, 0);
}
/**
 * 根绝出生时间计算年龄
 * @param birthTime 出生时间戳(秒)
 * @return age
 */
function getAgeFromBirth(birthTime) {
    if (!birthTime) {
        return '--';
    }
    var returnAge;
    var birthDate = new Date(birthTime * 1000);
    var birthYear = birthDate.getFullYear();
    var birthMonth = birthDate.getMonth();
    var birthDay = birthDate.getDate();

    var d = new Date();
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth();
    var nowDay = d.getDate();

    if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0岁
    } else {
        var ageDiff = nowYear - birthYear; //年之差

        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay; //日之差

                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                var monthDiff = nowMonth - birthMonth; //月之差

                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = '未知'; //返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge; //返回周岁年龄
}
/** 验证url合法性 */
function isValidURL(url) {
    // var urlRegExp=/^((https|http|ftp|rtsp|mms)?:\/\/)+[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*$/;
    var urlRegExp = /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[^\s]*$/;

    if (urlRegExp.test(url)) {
        return true;
    } else {
        return false;
    }
}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var filters_namespaceObject = {};
__webpack_require__.d(filters_namespaceObject, "filterDate", function() { return filterDate; });
__webpack_require__.d(filters_namespaceObject, "filterFixed", function() { return filterFixed; });
__webpack_require__.d(filters_namespaceObject, "percentTextFilter", function() { return percentTextFilter; });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/header/header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var header = ({
    data: function data() {
        return {
            scrollX: 0, // 水平滚动距离，用于fixed定位的导航条left值
            checkMesTimer: null,
            isLogin: false,
            newUserAlertFlag: false
        };
    },

    computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])({
        userInfo: function userInfo(state) {
            return state.userInfo.userInfo;
        }
    })),
    created: function created() {
        var _this = this;
    },
    mounted: function mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },

    methods: {
        fnLogout: function fnLogout() {
            var _this2 = this;

            this.$post('/User/loginOut', {}, function (resp) {
                if (resp.code == 1) {
                    if (_this2.userInfo.user_type == 3) {
                        if (location.host.indexOf('zsdx.cn') >= 0) {
                            location.href = 'http://www.zsdx.cn/dispatch';
                        } else {
                            location.href = 'http://gt.wxhand.com/dispatch';
                        }
                    } else {
                        _this2.$router.replace({ name: 'Login' });
                    }
                    _this2.$store.commit('SET_LOG_OUT');
                } else {
                    _this2.$message({
                        type: 'warning',
                        message: resp.msg,
                        center: true
                    });
                }
            });
        },

        /**
         * 垂直滚动时，判断导航条是否fixed定位
         */
        handleScroll: function handleScroll(e) {
            this.scrollX = -window.scrollX;
            if (this.fixedFlag && window.scrollY <= 81) {
                this.fixedFlag = false;
            } else if (!this.fixedFlag && window.scrollY > 81) {
                this.fixedFlag = true;
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this.checkMesTimer) {
            clearInterval(this.checkMesTimer);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90d3c0be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"centered"},[_c('h1',{staticClass:"pointer",on:{"click":_vm.commonJumpHome}}),_vm._v(" "),(_vm.userInfo.user_type == 1 || _vm.userInfo.user_type == 3)?_c('router-link',{staticClass:"navigator",attrs:{"to":"/project"}},[_vm._v("我的项目")]):_vm._e(),_vm._v(" "),(_vm.userInfo.user_type == 1)?_c('router-link',{staticClass:"navigator",attrs:{"to":{name: 'Talents'}}},[_vm._v("人才库")]):_vm._e(),_vm._v(" "),(_vm.userInfo.user_type == 1)?_c('router-link',{staticClass:"navigator",attrs:{"to":"/conversion"}},[_vm._v("转化跟踪")]):_vm._e(),_vm._v(" "),(_vm.userInfo.user_type == 1)?_c('router-link',{staticClass:"navigator",attrs:{"to":"/landing"}},[_vm._v("我的落地页")]):_vm._e(),_vm._v(" "),(_vm.userInfo.user_type == 1 || _vm.userInfo.user_type == 3)?_c('div',{staticClass:"user-wrapper"},[_c('span',{staticClass:"user-head",style:('background-image: url('+_vm.userInfo.header+')')}),_vm._v(" "),_c('span',{staticClass:"username"},[_vm._v(_vm._s(_vm.userInfo.nick_name))]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.fnLogout}},[_vm._v("退出")])],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var header_header = (esExports);
// CONCATENATED MODULE: ./src/components/header/header.vue
function injectStyle (ssrContext) {
  __webpack_require__("1B7o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90d3c0be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  header,
  header_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_header_header = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//


/* harmony default export */ var App = ({
    name: 'app',
    components: {
        navHeader: components_header_header
    },
    data: function data() {
        return {
            showHeader: false,
            show: false
        };
    },

    methods: {
        getUserInfo: function getUserInfo() {
            var _this = this;

            this.$post('/UserCenter/getSimpleUserInfo', {}, function (resp) {
                if (resp.code == 1) {
                    _this.$store.commit('SET_USER_INFO', resp.data);
                }
            });
        },
        getLoginStatus: function getLoginStatus() {
            var _this2 = this;

            this.$post('/User/getUserLoginStatus', {}, function (resp) {
                if (resp.code == 1) {
                    if (resp.data.status == 1) {
                        _this2.getUserInfo();
                    }
                }
            });
        },

        /** 无法通过vuerouter获取自路由中的param??? */
        getUrlPara: function getUrlPara(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);

            if (r != null) return r[2];return null;
        },
        oauth: function oauth(token, callback) {
            var _this3 = this;

            this.$post('/User/oauthLogin', {
                oauth_token: token
            }, function (resp) {
                if (resp.code == 1) {
                    callback();
                } else {
                    _this3.$message({
                        type: 'warning',
                        message: resp.msg,
                        center: true
                    });
                }
            });
        }
    },
    created: function created() {
        var _this4 = this;

        var ticket = this.getUrlPara('ticket');
        var token = this.getUrlPara('oauth_token');

        if (token) {
            this.oauth(token, function () {
                _this4.show = true;
                _this4.getLoginStatus();
                _this4.$router.replace({
                    query: {
                        oauth_token: null
                    }
                });
            });
        } else if (ticket) {
            this.show = true;
            // 重置sessionticket
            this.setSessionTicket(ticket);
            this.getLoginStatus();
        } else {
            this.show = true;
            this.getLoginStatus();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c6d4979","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-header'),_vm._v(" "),(_vm.show)?_c('router-view'):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("nvEQ")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
    mode: "history",
    routes: [{
        path: '/',
        redirect: '/project/list'
    },

    // 登陆
    {
        path: '/login',
        name: 'Login',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6Qob")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },

    // 项目
    {
        path: '/project',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yEQ8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        children: [{
            path: '/',
            redirect: 'list'
        }, {
            path: 'list',
            name: 'ProjectListActive',
            component: function component(resolve) {
                return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hQfR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: 'filed-list',
            name: 'ProjectListFiled',
            component: function component(resolve) {
                return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("21tC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: 'detail',
            component: function component(resolve) {
                return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iYXY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            },
            children: [{
                path: 'recruitment',
                name: 'ProjectDetailRecruitment',
                component: function component(resolve) {
                    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SxXh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                }
            }, {
                path: 'interview',
                name: 'ProjectDetailInterview',
                component: function component(resolve) {
                    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SxXh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                }
            }, {
                path: 'training',
                name: 'ProjectDetailTraining',
                component: function component(resolve) {
                    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SxXh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                }
            }, {
                path: 'execution',
                name: 'ProjectDetailExecution',
                component: function component(resolve) {
                    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5Q8W")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                }
            }, {
                path: 'ending',
                name: 'ProjectDetailEnding',
                component: function component(resolve) {
                    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Lk2q")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                }
            }]
        }, {
            path: 'settings',
            name: 'ProjectSettings',
            component: function component(resolve) {
                return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("r0to")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: 'task',
            component: function component(resolve) {
                return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Zn5v")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            },
            children: [{
                path: '/',
                redirect: '/404'
            }, {
                path: 'add',
                name: 'ProjectTaskAdd',
                component: function component(resolve) {
                    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SMRJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                }
            }, {
                path: 'edit',
                name: 'ProjectTaskEdit',
                component: function component(resolve) {
                    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SMRJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                }
            }, {
                path: 'detail',
                name: 'ProjectTaskDetail',
                component: function component(resolve) {
                    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BJOO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                }
            }]
        }]
    },

    // 大使
    {
        path: '/ambassador',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+Nbs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        children: [{
            path: '/',
            redirect: 'list'
        }, {
            path: 'list',
            name: 'AmbassadorList',
            component: function component(resolve) {
                return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("V5QZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: 'detail',
            name: 'AmbassadorDetal',
            component: function component(resolve) {
                return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("djG8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }]
    },

    // 客户
    {
        path: '/customer',
        name: 'Customer',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fTWI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    //分析页面
    {
        path: '/analysis/:active',
        name: 'Analysis',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5HuF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },

    // 人才库
    {
        path: '/talents',
        name: 'Talents',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hb3+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },

    //转化跟踪
    {
        path: '/conversion',
        name: 'Conversion',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HVLE")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },

    // 落地页
    {
        path: '/landing',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Jg7Z")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        children: [{
            path: '/',
            name: 'Landing',
            redirect: 'list/landing'
        }, {
            path: 'list/:active',
            name: 'LandingList',
            component: function component(resolve) {
                return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8cIh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: 'add',
            name: 'LandingAdd',
            component: function component(resolve) {
                return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bBii")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: 'edit',
            name: 'LandingEdit',
            component: function component(resolve) {
                return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bBii")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: 'config_form',
            name: 'LandingconfigForm',
            component: function component(resolve) {
                return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("quol")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }]
    },

    // 404
    {
        path: '/404',
        name: '404',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("U4kt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },

    // 全局重定向
    {
        path: '*',
        redirect: '/404'
    }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/types/mutation-types.js
/*
 * mutation-types 在此配置mutations的type
 * @Author: ice
 * @Date: 2017-07-24 19:21:07
 * @Last Modified by: ice
 * @Last Modified time: 2017-11-24 16:49:27
 */
// 设置用户信息
var SET_USER_INFO = 'SET_USER_INFO';
// 设置登出
var SET_LOG_OUT = 'SET_LOG_OUT';
// CONCATENATED MODULE: ./src/store/modules/user-info.js


var _mutations;

/*
 * @Author: zhaoyi
 * @Date: 2017-09-11 11:11:01
 * @Last Modified by: ice
 * @Last Modified time: 2018-06-19 16:42:13
 */


var state = {
    userInfo: {
        'user_type': 0, // 用户类型:1常规, 2游客, 3广告主, 0未登录
        'nick_name': '',
        'manager_no': '',
        'is_admin': 0,
        'header': 'http://cdn.wxhand.com/amb/images/header.png'
    }
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, SET_USER_INFO, function (state, userInfo) {
    state.userInfo.user_type = userInfo.user_type;
    state.userInfo.is_admin = userInfo.is_admin;
    state.userInfo.nick_name = userInfo.nick_name;
    state.userInfo.header = userInfo.user_head ? userInfo.user_head : 'http://cdn.wxhand.com/amb/images/header.png';
    state.userInfo.manager_no = userInfo.manager_no;
}), defineProperty_default()(_mutations, SET_LOG_OUT, function (state) {
    state.userInfo.user_type = 0;
    state.userInfo.nick_name = '';
    state.userInfo.is_admin = 0;
}), _mutations);

/* harmony default export */ var user_info = ({
    state: state,
    mutations: mutations
});
// CONCATENATED MODULE: ./src/store/index.js




vue_esm["default"].use(vuex_esm["a" /* default */]);
/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
    modules: {
        userInfo: user_info
    }
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/define-properties.js
var define_properties = __webpack_require__("HSQo");
var define_properties_default = /*#__PURE__*/__webpack_require__.n(define_properties);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/assets/js/axios.js






var sessionTicket = '';
var getSessionTicketUrl = '/Basic/createSessionTicket';
var gettingSessionTicket = false;
var getSessionTicketTimes = 0;

axios_default.a.defaults['withCredentials'] = true;

var axios_axios = axios_default.a.create({
    baseURL: window.location.host.indexOf('zsdx.cn') > -1 ? "https://amb2-api.zsdx.cn/manager" : "http://amb2-api-dev.wxhand.com/manager",
    transformRequest: [function (data, headers) {
        var resData = data;

        if (!(resData instanceof FormData)) {
            resData = lib_default.a.stringify(resData);
        }
        return resData;
    }],
    method: 'post'
});

axios_axios.interceptors.request.use(function (config) {
    // 这里的config包含每次请求的内容
    config.headers['zsdx-session-ticket'] = sessionTicket;
    return config;
}, function (err) {
    return promise_default.a.reject(err);
});

function getSessionTicketLocal() {
    if (!sessionTicket) {
        sessionTicket = localStorage.sessionTicket;
    }

    return sessionTicket;
}

/** 向服务器索取新的sessionTicket */
function getSessionTicketRemote(callback) {
    if (getSessionTicketTimes > 10) {
        vue_esm["default"].prototype.$notify.error({
            title: '错误',
            message: '服务器错误，请稍后重试'
        });
        return;
    }
    gettingSessionTicket = true;
    axios_axios.post(getSessionTicketUrl, {}).then(function (response) {
        if (response.status != '200') {
            return promise_default.a.reject(res);
        }
        var resp = response.data;

        if (resp.code == 1) {
            // 重置请求次数
            getSessionTicketTimes = 0;
            sessionTicket = resp.data.session_ticket;
            // 本地存储
            localStorage.sessionTicket = sessionTicket;
        }
        gettingSessionTicket = false;
        getSessionTicketTimes++;
        if (callback) {
            callback(sessionTicket);
        }
    }).catch(function (err) {
        gettingSessionTicket = false;
        getSessionTicketTimes++;
        return promise_default.a.reject(err);
    });
}

/** 获取sessiongTicket */
function getSessionTicket(callback) {
    var st = '';

    if (gettingSessionTicket) {
        setTimeout(function () {
            callback('');
        }, 200);
        return;
    }
    st = getSessionTicketLocal();
    if (st) {
        callback(st);
    } else {
        getSessionTicketRemote(function (st) {
            callback(st);
        });
    }
}
/**
 * 处理请求返回结果
 * @param resp axios返回原始数据,
 * @param instance 调用接口原始vue实例
 */
function dealResponse(resp, options) {
    if (resp.status != '200') {
        return promise_default.a.reject(res);
    }

    var instance = options.instance;

    // sessionTicket缺失或者失效
    if (resp.data.code == 1001) {
        if (gettingSessionTicket) {
            setTimeout(function () {
                instance.$post(options.url, options.data, options.success, options.fail);
            }, 200);
            return;
        }
        getSessionTicketRemote(function (currTicket) {
            instance.$post(options.url, options.data, options.success, options.fail, currTicket);
        });
        return;
    }

    // 未登录
    if (resp.data.code == 1002) {
        instance.$router.push({
            name: 'Login',
            params: {
                dist: {
                    path: instance.$route.path,
                    query: instance.$route.query
                }
            }
        });
        return;
    }

    // 用户未审核或者审核未通过
    if (resp.data.code == 1004 || resp.data.code == 1005) {
        instance.$notify({
            type: 'warning',
            title: '警告',
            message: '您的账户' + resp.data.code == 1004 ? '正在审核中，请等待处理后再操作' : '审核未通过'
        });
        return;
    }

    // 未绑定手机号
    if (resp.data.code == 1006) {
        instance.$router.push({
            name: 'bind',
            query: {
                dist: {
                    pageName: instance.$route.name,
                    query: instance.$route.query
                }
            }
        });
        return;
    }

    // 代理信息相关提示
    if (resp.data.code == 1007 || resp.data.code == 1008) {
        instance.$notify({
            type: 'warning',
            title: '警告',
            message: '代理信息错误，请联系客服'
        });
        return;
    }

    if (options.success) {
        options.success(resp.data);
    }
}

/** 清除客户端保留sessionTicket */
function clearSessionTicket() {
    if (sessionTicket == localStorage.sessionTicket) {
        localStorage.sessionTicket = undefined;
    }
    sessionTicket = undefined;
}
/** 手动设置sessionTicket */
function setSessionTicket(ticket) {
    sessionTicket = ticket;
    // 本地存储 防止出现覆盖管理员身份,只是保存临时变量,刷新丢失
    localStorage.sessionTicket = ticket;
}

/**
 * 一般post请求
 * @param
 */
function post(url, data, success, fail, session_ticket) {
    var instance = this;
    var st = session_ticket;

    if (!st && url != getSessionTicketUrl) {
        getSessionTicket(function (currTicket) {
            instance.$post(url, data, success, fail, currTicket);
        });
    } else {
        axios_axios.post(url, data).then(function (resp) {
            dealResponse(resp, {
                instance: instance,
                url: url,
                data: data,
                success: success,
                fail: fail
            });
        }).catch(function (err) {
            if (fail) {
                fail(err);
            }
            return promise_default.a.reject(err);
        });
    }
}

/**
 * 上传文件请求
 * @param options 请求相关配置{url, data, progress(上传进度), success, fail}
 * @param session_ticket ticket
 */
function upload(options, session_ticket) {
    var instance = this;
    var st = session_ticket;

    if (!st && options.url != getSessionTicketUrl) {
        getSessionTicket(function (currTicket) {
            instance.$upload(options, currTicket);
        });
    } else {
        axios_axios.post(options.url, options.data, {
            onUploadProgress: function onUploadProgress(e) {
                if (e.total > 0) {
                    e.percent = e.loaded / e.total * 100;
                }
                if (options.progress) {
                    options.progress(e);
                }
            }
        }).then(function (resp) {
            dealResponse(resp, {
                instance: instance,
                url: options.url,
                data: options.data,
                success: options.success,
                fail: options.success
            });
        }).catch(function (err) {
            if (options.fail) {
                options.fail(err);
            }
            return promise_default.a.reject(err);
        });
    }
}

function install(Vue, options) {
    Vue.axios = axios_default.a;

    define_properties_default()(Vue.prototype, {
        $post: {
            get: function get() {
                return post.bind(this);
            }
        },
        $upload: {
            get: function get() {
                return upload.bind(this);
            }
        },
        axios: {
            get: function get() {
                return axios_axios;
            }
        },
        clearSessionTicket: {
            get: function get() {
                return clearSessionTicket;
            }
        },
        setSessionTicket: {
            get: function get() {
                return setSessionTicket;
            }
        }
    });
}

/* harmony default export */ var js_axios = ({
    install: install
});
// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./src/assets/js/util.js
var util = __webpack_require__("LOkV");

// CONCATENATED MODULE: ./src/assets/js/filters.js


function filterDate(val, format) {
    if (val == 'NaN') {
        return '--';
    } else if (val) {
        return Object(util["a" /* dateFormatter */])(val * 1000, format);
    } else {
        return '--';
    }
}

function filterFixed(val) {
    var fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var empty = arguments[2];

    var zero = 0;

    if (!val) {
        return empty ? empty : zero.toFixed(fixed);
    }
    var num = parseFloat(val);

    if (num == 0) {
        return empty ? empty : zero.toFixed(fixed);
    }
    return num.toFixed(fixed);
}

function percentTextFilter(val) {
    if (val <= 1) {
        return '前1%';
    }
    if (val <= 2) {
        return '前2%';
    }
    if (val <= 5) {
        return '前5%';
    }
    if (val <= 10) {
        return '前10%';
    }
    if (val <= 20) {
        return '前20%';
    }
    if (val <= 30) {
        return '前30%';
    }
    if (val <= 50) {
        return '前50%';
    }
    return '大于前50%';
}


// EXTERNAL MODULE: ./node_modules/vue-html5-editor/dist/vue-html5-editor.js
var vue_html5_editor = __webpack_require__("g6v0");
var vue_html5_editor_default = /*#__PURE__*/__webpack_require__.n(vue_html5_editor);

// EXTERNAL MODULE: ./static/css/reset.css
var css_reset = __webpack_require__("EWIa");
var reset_default = /*#__PURE__*/__webpack_require__.n(css_reset);

// EXTERNAL MODULE: ./static/css/element-ui.css
var element_ui = __webpack_require__("lgg4");
var element_ui_default = /*#__PURE__*/__webpack_require__.n(element_ui);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./static/font/iconfont.css
var iconfont = __webpack_require__("uKUT");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













var editorOptions = {
    name: "vue-html5-editor",
    // 是否显示模块名称，开启的话会在工具栏的图标后台直接显示名称
    // if set true,will append module name to toolbar after icon
    showModuleName: false,
    // 自定义各个图标的class，默认使用的是font-awesome提供的图标
    // custom icon class of built-in modules,default using font-awesome
    icons: {},
    // 配置图片模块
    // config image module
    image: {
        // 文件最大体积，单位字节  max file size
        // sizeLimit: 512 * 1024,
        sizeLimit: 1024 * 1024 * 1024,
        // 上传参数,默认把图片转为base64而不上传
        // upload config,default null and convert image to base64
        upload: {
            url: (window.location.host == 'amb2-dev.wxhand.com' ? "http://amb2-api-dev.wxhand.com/manager" : "https://amb2-api.zsdx.cn/manager") + '/Upload/uploadPicture',
            headers: {
                'zsdx-session-ticket': localStorage.sessionTicket
            },
            params: {},
            fieldName: 'picture'
        },
        // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
        // compression config,default resize image by localResizeIMG (https://github.com/think2011/localResizeIMG)
        // set null to disable compression
        compress: {
            width: 1600,
            height: 1600,
            quality: 80
        },
        // 响应数据处理,最终返回图片链接
        // handle response data，return image url
        uploadHandler: function uploadHandler(responseText) {
            //default accept json data like  {ok:false,msg:"unexpected"} or {ok:true,data:"image url"}
            var json = JSON.parse(responseText);

            console.log(json);
            if (json.code != 1) {
                alert(json.msg);
            } else {
                return json.data.url;
            }
        }
    },
    // 语言，内建的有英文（en-us）和中文（zh-cn）
    //default en-us, en-us and zh-cn are built-in
    language: "zh-cn",
    // 自定义语言
    i18n: {
        //specify your language here
        "zh-cn": {
            "align": "对齐方式",
            "image": "图片",
            "list": "列表",
            "link": "链接",
            "unlink": "去除链接",
            "table": "表格",
            "font": "文字",
            "full screen": "全屏",
            "text": "排版",
            "eraser": "格式清除",
            "info": "关于",
            "color": "颜色",
            "please enter a url": "请输入地址",
            "create link": "创建链接",
            "bold": "加粗",
            "italic": "倾斜",
            "underline": "下划线",
            "strike through": "删除线",
            "subscript": "上标",
            "superscript": "下标",
            "heading": "标题",
            "font name": "字体",
            "font size": "文字大小",
            "left justify": "左对齐",
            "center justify": "居中",
            "right justify": "右对齐",
            "ordered list": "有序列表",
            "unordered list": "无序列表",
            "fore color": "前景色",
            "background color": "背景色",
            "row count": "行数",
            "column count": "列数",
            "save": "确定",
            "upload": "上传",
            "progress": "进度",
            "unknown": "未知",
            "please wait": "请稍等",
            "error": "错误",
            "abort": "中断",
            "reset": "重置"
        }
    },
    // 隐藏不想要显示出来的模块
    // the modules you don't want
    hiddenModules: [],
    // 自定义要显示的模块，并控制顺序
    // keep only the modules you want and customize the order.
    // can be used with hiddenModules together
    visibleModules: ["text", "color", "font", "align", "link", "unlink", "tabulation", "image", "hr", "undo",
    // "eraser",
    "reset"],
    // 扩展模块，具体可以参考examples或查看源码
    // extended modules
    modules: {
        //omit,reference to source code of build-in modules
    }
};

vue_esm["default"].config.productionTip = false;
vue_esm["default"].use(js_axios);
vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].use(vue_html5_editor_default.a, editorOptions);

keys_default()(filters_namespaceObject).forEach(function (key) {
    vue_esm["default"].filter(key, filters_namespaceObject[key]);
});

vue_esm["default"].mixin({
    methods: {
        /**
         * 跳转至主页面,根据身份
         * @param Object
         * @return Boolean
         */
        commonJumpHome: function commonJumpHome() {
            if (this.$store.state.userInfo.userInfo.user_type == 2) {
                this.$router.push({
                    name: 'Customer',
                    query: {
                        project_no: this.$route.query.project_no
                    }
                });
            } else {
                this.$router.push({ path: '/' });
            }
        }
    }
});

/* eslint-disable no-new */
new vue_esm["default"]({
    el: '#app',
    router: router,
    store: store,
    template: '<App/>',
    components: { App: src_App }
});

/***/ }),

/***/ "lgg4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nvEQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uKUT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.188d7e5b39f3aafeba19.js